import React from "react";
export default function Skillset(props) {
  return (
    <div
      className="w-40 h-24 lg:w-56 lg:h-32 flex flex-col items-center justify-center bg-gray-900"
      style={{ margin: "0.125em" }}
    >
      <div className="pb-2">{props.skillsetIcon}</div>
      <p className="text-xs font-semibold">{props.title}</p>
    </div>
  );
}
